// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { orderTotalDisplaySharedStyles } from "@synd/App/SharedStyles/MyAccountPages/Details/OrderTotalDisplaySharedStyles";
import { cartTotalDisplayStyles } from "@synd/Overrides/Components/CartTotalDisplay";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { mergeWithCss } from "@synd/XDL/Utilities";
import { css } from "styled-components";

cartTotalDisplayStyles.container = {
    ...orderTotalDisplaySharedStyles.mainContainer,
};

cartTotalDisplayStyles.fullWidthGridItem = {
    width: 12,
};
cartTotalDisplayStyles.labelGridItem = {
    ...orderTotalDisplaySharedStyles.labelGridItem,
};
cartTotalDisplayStyles.valueGridItem = {
    ...orderTotalDisplaySharedStyles.valueGridItem,
};
cartTotalDisplayStyles.totalLabel = {
    ...orderTotalDisplaySharedStyles.totalLabel,
};
cartTotalDisplayStyles.totalValue = {
    ...orderTotalDisplaySharedStyles.totalValue,
};
cartTotalDisplayStyles.subtotalLabel = {
    ...orderTotalDisplaySharedStyles.label,
};
cartTotalDisplayStyles.subtotalValue = {
    ...orderTotalDisplaySharedStyles.value,
};
cartTotalDisplayStyles.promotionLabel = {
    ...mergeWithCss(orderTotalDisplaySharedStyles.label, {
        css: css`
            > ${TypographyStyle} {
                font-size: ${fontConfig.xSmallSingleLine.size}px;
                line-height: ${fontConfig.xSmallSingleLine.lineHeight};
                display: block;
                margin-top: 4px;
            }
        `,
    }),
};
cartTotalDisplayStyles.promotionValue = {
    ...orderTotalDisplaySharedStyles.value,
};
cartTotalDisplayStyles.shippingAndHandlingLabel = {
    ...mergeWithCss(orderTotalDisplaySharedStyles.label, {
        css: css`
            @media print {
                display: inline;
            }
        `,
    }),
};
cartTotalDisplayStyles.shippingAndHandlingValue = {
    ...orderTotalDisplaySharedStyles.value,
};
cartTotalDisplayStyles.taxLabel = {
    ...orderTotalDisplaySharedStyles.label,
};
cartTotalDisplayStyles.taxValue = {
    ...orderTotalDisplaySharedStyles.value,
};
cartTotalDisplayStyles.discountsLabel = {
    ...orderTotalDisplaySharedStyles.label,
};
cartTotalDisplayStyles.discountsValue = {
    ...orderTotalDisplaySharedStyles.value,
};

cartTotalDisplayStyles.shippingTooltipIcon = {
    ...orderTotalDisplaySharedStyles.shippingTooltipIcon,
};
